import Lenis from 'lenis';
import { gsap } from '../gsap-3.13.0.min';
import { ScrollTrigger } from '../ScrollTrigger.min';

export default {
  init() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });

    const lenis = new Lenis({
      lerp: 0.12,        // 追従速度（0.1=ぬるい ↔ 0.2=キビキビ）
      wheelMultiplier: 1.0,
    });

    // Lenis v1.x 推奨: gsap.ticker でフレーム管理
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);

    lenis.on('scroll', () => {
      ScrollTrigger.update();
    });
  },
};
